export default "__VITE_ASSET__BOsIqs9r__"